import { Navigate } from 'react-router-dom';
import { useAuth, hasPermiso } from 'src/contexts/AuthContext';

interface PermissionGuardProps {
  /** Códigos de permiso: el usuario debe tener al menos uno (o ser SuperAdmin). Si no se pasa, se permite acceso. */
  permisos?: string[];
  /** Si true, solo SuperAdmin puede acceder. */
  requireSuperAdmin?: boolean;
  /** Si no tiene permiso y se pasa fallback, se muestra en lugar de redirigir a 404. */
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Envuelve rutas que requieren permiso. Si el usuario no tiene acceso, redirige a 404.
 */
export default function PermissionGuard({ permisos, requireSuperAdmin, fallback, children }: PermissionGuardProps) {
  const { user } = useAuth();

  if (requireSuperAdmin) {
    const isSuperAdmin = user?.esSuperAdmin ?? !user?.empresa;
    if (!isSuperAdmin) return <Navigate to="/status/404" replace />;
    return <>{children}</>;
  }

  if (!permisos || permisos.length === 0) {
    return <>{children}</>;
  }

  const permitido = permisos.some((codigo) => hasPermiso(user, codigo));
  if (!permitido) {
    if (fallback != null) return <>{fallback}</>;
    return <Navigate to="/status/404" replace />;
  }

  return <>{children}</>;
}
